import { Pipe, PipeTransform } from '@angular/core';

/** Pure pipe so per-row classes are computed on row change, not every change detection. */
@Pipe({ name: 'vsTableRowClasses', standalone: false })
export class TableRowClassesPipe implements PipeTransform {
  transform<T>(item: T, rowClasses?: (item: T) => string) {
    return rowClasses?.(item) ?? '';
  }
}
